import Vue from "vue";
import Router from "vue-router";
import Components from "./pages/Components.vue";
import Presentation from "./pages/Presentation.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import Home from "./pages/HomePage.vue";
import About from "./pages/example-pages/AboutUs.vue";
import BlogPost from "./pages/example-pages/BlogPost.vue";
import BlogPosts from "./pages/example-pages/BlogPosts.vue";
import ContactUs from "./pages/example-pages/ContactUs.vue";
import LandingPage from "./pages/example-pages/LandingPage.vue";
import PricingPage from "./pages/example-pages/PricingPage.vue";
import EcommercePage from "./pages/example-pages/EcommercePage.vue";
import ProductPage from "./pages/example-pages/ProductPage.vue";
import ProfilePage from "./pages/example-pages/ProfilePage.vue";
import SignUpPage from "./pages/SignUpPage.vue";
import LoginPage from "./pages/LoginPage.vue";
import Sections from "./pages/Sections.vue";

import store from './store/store'
import Videos from "./sarel/pages/Videos.vue";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedUser) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  console.log('ifAuthenticated')
  if (store.getters.isLoggedUser) {
    next()
    return
  }
  next('/signin')
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      //components: { default: Home, header: MainNavbar, footer: MainFooter },
      components: { default: Home, header: MainNavbar },
      //components: { default: Home },
      //props: { header: { transparent: false, colorOnScroll: 450 } },
      props: { header: { transparent: false } },
    },
    {
      path: "/signin",
      name: "signin",
      //components: { default: LoginPage },
      components: { default: LoginPage, header: MainNavbar },
      props: { header: { transparent: false } },
      meta: {
        hideForLogin: true
      },
      //beforeEnter: ifNotAuthenticated,
    },
    {
      path: "/videos",
      name: "videos",
      //components: { default: Videos },
      components: { default: Videos, header: MainNavbar },
      props: {
        footer: { backgroundColor: 'black' },
        header: { transparent: false }//colorOnScroll: 65
      },
      meta: {
        requiresLogin: true
      },
      //beforeEnter: ifAuthenticated,
      /*beforeEnter(to , form, next) {
        //if (!store.getters.isLoggedUser) {
        if (store.state.accessToken === null) {
          next({ path: '/signin' })
        } else {
          next()
        }
      },*/
    },
    /*{
      path: "/components",
      name: "components",
      components: {default: Components, header: MainNavbar, footer: MainFooter},
      props: {
        footer: {backgroundColor: 'black'},
        header: {colorOnScroll: 65}
      }
    },
    {
      path: "/presentation",
      name: "presentation",
      components: {default: Presentation, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 500}}
    },
    {
      path: "/about",
      name: "about",
      components: {default: About, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/contact",
      name: "contact",
      components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
      props: {footer: {type: 'default'}}
    },
    {
      path: "/landing",
      name: "landing",
      components: {default: LandingPage, header: MainNavbar, footer: MainFooter},
      props: {footer: {type: 'default'}, header: {colorOnScroll: 450}}
    },
    {
      path: "/pricing",
      name: "pricing",
      components: {default: PricingPage, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/blog-post",
      name: "blog-post",
      components: {default: BlogPost, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/blog-posts",
      name: "blog-posts",
      components: {default: BlogPosts, header: MainNavbar},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/ecommerce",
      name: "ecommerce",
      components: {default: EcommercePage, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/product",
      name: "product",
      components: {default: ProductPage, header: MainNavbar},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/profile",
      name: "profile",
      components: {default: ProfilePage, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/signup",
      name: "signup",
      components: {default: SignUpPage}
    },
    {
      path: "/sections",
      name: "sections",
      components: {default: Sections, header: MainNavbar, footer: MainFooter},
      props: {
        footer: {backgroundColor: 'gray'},
        header: {colorOnScroll: 0}
      }
    }*/
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});

router.beforeEach((to, from, next) => {
  //var accessToken = localStorage.getItem('accessToken')
  //console.log(accessToken)
  if (!store.getters.doneInit) {
    store.dispatch('init', {}).then(next)
      .catch(e => {
        console.log(e)
      })
  }
  if (to.matched.some(record => record.meta.requiresLogin) && !store.getters.isLoggedUser) {
  //if (to.matched.some(record => record.meta.requiresLogin) && (accessToken === null)) {
    next({ path: '/signin' })
  } else if (to.matched.some(record => record.meta.hideForLogin) && store.getters.isLoggedUser) {
  //} else if (to.matched.some(record => record.meta.hideForLogin) && (accessToken !== null)) {
    next({ path: '/videos' })
  } else {
    next()
  }

  //if (to.matched.some(record => record.meta.hideForLogin) && store.getters.isLoggedUser) {
    //next("/videos")
  //} else {
    //next()
  //}
})

export default router;
